import { render, staticRenderFns } from "./seriesLabelPop.vue?vue&type=template&id=71f59d44&scoped=true&"
import script from "./seriesLabelPop.vue?vue&type=script&lang=js&"
export * from "./seriesLabelPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f59d44",
  null
  
)

export default component.exports